// const baseUrl = `https://apiv2.bulletproofforbjj.com/api/v1/`;
// const baseUrl = `http://170.64.224.80:3000/api/v1/`;
const profileFileUrl = `https://apiv2.bulletproofforbjj.com/files/`;
const fileUrl = `https://d3742cffkcu4i8.cloudfront.net/`;

// const baseUrl = `http://localhost:3000/api/v1/`;

//staging
// const baseUrl = `https://bjj-staging.castledigital.com.au/api/v1/`;

// production
const baseUrl = `https://bp-bjj-backend-871334943140.australia-southeast1.run.app/api/v1/`;

// const baseUrl = `https://devapi.bulletproofforbjj.com/api/v1/`;
// const profileFileUrl = `https://devapi.bulletproofforbjj.com/files/`;
// const fileUrl = `https://d3742cffkcu4i8.cloudfront.net/`;

// const baseUrl = `http://192.168.0.147:3000/api/v1/`;
// const fileUrl = `https://192.168.0.111:5019/files/`;

// const baseUrl = `https://apitest.bulletproofforbjj.com//api/v1/`;
// const profileFileUrl = `https://apitest.bulletproofforbjj.com/files/`;

export { baseUrl, fileUrl, profileFileUrl };
